(function(){

    /* Debounce (se ti servirà altrove) */
    const debounce=(fn,ms=100)=>{let t;return(...a)=>{clearTimeout(t);t=setTimeout(()=>fn(...a),ms)}};



    /*
    * === HERO VIDEO: autoplay universale, super performante ===
    * */
    (function setupHeroVideo(){
        var v = document.getElementById('heroVideo');
        if(!v) return;

        // Policy-friendly
        v.muted = true;
        v.setAttribute('playsinline','');
        v.setAttribute('webkit-playsinline','');
        v.setAttribute('loop','');
        v.setAttribute('preload','metadata');

        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var prefersReducedData   = (window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches) === true;
        var saveData             = (navigator.connection && navigator.connection.saveData) === true;

        // Se l'utente chiede di ridurre movimento/dati → non carichiamo le sorgenti
        if (prefersReducedMotion || prefersReducedData || saveData) {
            v.removeAttribute('autoplay');
            try { v.pause(); } catch(_){}
            return;
        }

        // Sposta data-src -> src una sola volta
        function hydrateSourcesOnce() {
            var hydrated = false;
            return function(){
                if (hydrated) return;
                var sources = v.querySelectorAll('source[data-src]');
                sources.forEach(function(s){
                    if(!s.src){ s.src = s.getAttribute('data-src'); }
                    s.removeAttribute('data-src');
                });
                v.load();
                hydrated = true;
            };
        }
        var hydrateSources = hydrateSourcesOnce();

        // Tentativi di play resilienti
        function tryPlay(){
            var p;
            try { p = v.play(); } catch(_) { /* no-op */ }
            if (p && typeof p.catch === 'function') {
                p.catch(function(){
                    // piccoli retry, useful su Safari/iOS
                    setTimeout(function(){ v.play().catch(function(){}); }, 80);
                });
            }
        }

        // Lazy hydration quando entra in viewport
        var io = new IntersectionObserver(function(entries){
            var visible = entries.some(function(e){ return e.isIntersecting; });
            if (visible) {
                hydrateSources();
                tryPlay();
                io.disconnect();
            }
        }, { rootMargin:'300px 0px', threshold:0.15 });

        io.observe(v);

        // Se già idratato (es. preload altrove), prova subito
        if (v.querySelector('source:not([data-src])')) {
            tryPlay();
        }

        // Riprendi se torni dalla bfcache
        window.addEventListener('pageshow', function(e){
            if (e.persisted) tryPlay();
        });

        // Risparmio batteria: pausa quando la tab non è visibile
        document.addEventListener('visibilitychange', function(){
            if (document.hidden) { try{ v.pause(); }catch(_){ } }
            else { tryPlay(); }
        });
    })();



    /*
    * Configurazione grid image/video
    * */

    /* Lazy IMG (come già avevi) */
    const lazyIO=new IntersectionObserver(entries=>{
        entries.forEach(e=>{
            if(!e.isIntersecting) return;
            const img=e.target;
            if(img.dataset.src){ img.src=img.dataset.src; img.removeAttribute('data-src'); }
            img.classList.remove('lazy');
            lazyIO.unobserve(img);
        });
    },{rootMargin:'400px 0px'});

    /* 1) Lazy VIDEO SOURCE: quando vicino al viewport settiamo <source src> e facciamo .load() */
    const videoSrcIO = new IntersectionObserver(entries=>{
        entries.forEach(e=>{
            if(!e.isIntersecting) return;
            const video = e.target;
            const src = video.querySelector('source[data-src]');
            if(src && !src.getAttribute('src')){
                src.setAttribute('src', src.dataset.src);
                src.removeAttribute('data-src');
                video.load(); // prepara i metadata
            }
            videoSrcIO.unobserve(video);
        });
    },{rootMargin:'600px 0px'}); // carica un po' prima

    /* 2) Play/Pause in viewport (>=25%) */
    const videoPlayIO = new IntersectionObserver(entries=>{
        entries.forEach(async e=>{
            const v=e.target;
            if(e.isIntersecting){
                try { await v.play(); } catch(_) { /* Safari può rifiutare: ignora */ }
            } else {
                v.pause();
                // se esce dal viewport ed è con audio attivo, spegni audio
                if(!v.muted){ setMuted(v, true); }
            }
        });
    },{threshold:0.25});

    /* Utilità: cambia stato audio + bottone */
    function setMuted(video, shouldMute){
        video.muted = shouldMute;
        const btn = video.parentElement.querySelector('.mute-btn');
        if(btn){
            btn.setAttribute('aria-pressed', String(!shouldMute));
            btn.setAttribute('aria-label', shouldMute ? 'Attiva audio' : 'Disattiva audio');
        }
    }

    /* Disattiva audio a tutti gli altri video quando uno viene smutato */
    function muteAllExcept(video){
        document.querySelectorAll('.grid-video').forEach(v=>{
            if(v!==video && !v.muted){ setMuted(v, true); }
        });
    }

    /* Setup */
    window.addEventListener('DOMContentLoaded', ()=>{
        const grid = document.getElementById('project-grid');
        if(!grid) return;

        // IMG lazy
        grid.querySelectorAll('img.lazy').forEach(i=>lazyIO.observe(i));

        // VIDEO
        grid.querySelectorAll('video.grid-video').forEach(v=>{
            // lazy del sorgente video
            videoSrcIO.observe(v);

            // auto play/pause in viewport
            videoPlayIO.observe(v);

            // forza impostazioni performance
            v.setAttribute('playsinline','');
            v.setAttribute('loop','');
            v.setAttribute('preload','metadata');
            // tutti partono MUTED per policy/autoplay
            v.muted = true;

            // bottone toggle (solo sui .v-toggle)
            const btn = v.parentElement.querySelector('.mute-btn');
            if(btn){
                btn.addEventListener('click', async ()=>{
                    // sblocca l'audio con gesto utente
                    const willUnmute = v.muted;
                    if(willUnmute){
                        muteAllExcept(v);
                        setMuted(v,false);
                        v.volume = 0.9; // volume ragionevole
                        try { await v.play(); } catch(_) {}
                    } else {
                        setMuted(v,true);
                    }
                }, {passive:true});
            }
        });

        // opzionale: spegni audio quando la tab perde il focus
        document.addEventListener('visibilitychange', ()=>{
            if(document.visibilityState !== 'visible'){
                document.querySelectorAll('.grid-video').forEach(v=>{ if(!v.muted) setMuted(v,true); v.pause(); });
            }
        });
    });



    /*
    * Inizializzazione Swiper.js per CH relative
    * */
    document.addEventListener('DOMContentLoaded', function () {
        var el = document.querySelector('.swiperCH');
        if (!el || typeof window.Swiper === 'undefined') return;
        var n = el.querySelectorAll('.swiper-slide').length;
        if (!n) return;
        new Swiper(el, {
            slidesPerView: 1.75,
            spaceBetween: 15,
            navigation: {
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                1200: {
                    slidesPerView: 3.4
                },
                1400: {
                    slidesPerView: 3.4
                },
            }
        });
    });


})();
